/* ========================================
   SHIMADA CUSTOM JS
   ======================================== */

// Product Page: Video Autoplay

if (document.body.classList.contains('template-product')) {
  const initProductVideoAutoplay = () => {
    document.querySelectorAll('product-gallery[autoplay-media]').forEach((gallery) => {
      const media = gallery.querySelector('.product-gallery__media.is-initial');

      if (media?.dataset.mediaType !== 'video') return;
      const videoMedia = media.querySelector('video-media');
      if (!videoMedia) return;
      const video = videoMedia.querySelector('video');

      if (video) {
        video.controls = false;
      }

      videoMedia.removeAttribute('show-play-button');

      if (!videoMedia.playing) {
        videoMedia.play();
      }
    });
  };

  if (document.readyState === 'complete') {
    initProductVideoAutoplay();
  } else {
    window.addEventListener('load', initProductVideoAutoplay, { once: true });
  }
}

